//export const API_BASE_URL = 'http://localhost:8082';
//export const API_BASE_URL = 'https://al-bawsala-backend-production-f68c.up.railway.app';
export const API_BASE_URL = 'http://54.227.183.93:8082/api';